<template>
  <v-card flat>
    <v-card-title class="subtitle-1 primary--text">
      {{ titulo }}
    </v-card-title>
    <v-card-text>
      <v-row dense>
        <v-col>
          <v-menu
            v-model="dialog"
            :close-on-content-click="false"
            :nudge-width="500"
            offset-y
          >
            <template v-slot:activator="{ on: onMenu }">
              <v-tooltip top>
                <template v-slot:activator="{ on: onTooltip }">
                  <v-btn
                    color="primary"
                    text
                    :disabled="cursosInstrutorDoTipo.length >= maximo"
                    @click="toogleForm"
                    v-on="{ ...onTooltip, ...onMenu }"
                  >
                    Adicionar
                    <v-icon class="ml-2">
                      add_circle
                    </v-icon>
                  </v-btn>
                </template>
                <span>Clique para adicionar um curso</span>
              </v-tooltip>
            </template>
            <v-card class="pa-5">
              <v-card-title>
                <h5 class="headline primary--text text-no-wrap">
                  {{ isEdicao ? "Edição" : "Cadastro" }} de Curso
                </h5>
              </v-card-title>
              <v-card-subtitle>Informe os dados do curso</v-card-subtitle>
              <v-card-text>
                <v-form
                  ref="form"
                  v-model="valid"
                  @submit.prevent="save"
                >
                  <v-row>
                    <v-text-field
                      v-model.trim="curso.nome"
                      label="Nome do curso"
                    />
                  </v-row>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-row class="justify-end mr-4">
                  <v-btn
                    :disabled="curso.nome.trim() === ''"
                    class="mr-2"
                    color="primary"
                    @click="save"
                  >
                    {{ isEdicao ? "Editar" : "Cadastrar" }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    outlined
                    @click="toogleForm"
                  >
                    Cancelar
                  </v-btn>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-menu>
          <v-chip
            v-for="c in cursosInstrutorDoTipo"
            :key="c.id"
            color="secondary"
            text-color="white"
            class="ml-2"
            close
            @click:close="remove(c)"
          >
            {{ c.nome }}
          </v-chip>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const cursoInstrutorRepository = RepositoryFactory.get('cursoInstrutor');

export default {
  name: 'CursoInstrutorForm',

  props: {
    titulo: {
      type: String,
      default: 'Informe os cursos',
      required: false,
    },
    maximo: {
      type: Number,
      default: 100,
      required: false,
    },
    tipo: {
      type: String,
      default: 'CAPACITACAO',
      required: false,
    },
  },

  data() {
    return {
      curso: {
        id: null,
        nome: '',
        tipo: this.tipo,
      },
      dialog: false,
      valid: false,
      isEdicao: false,
    };
  },

  computed: {
    ...mapState({
      perfil: (state) => state.auth.usuario.perfil,
    }),
    cursosInstrutorDoTipo() {
      return this.perfil.cursosInstrutor.filter((c) => c.tipo === this.tipo);
    },
  },

  methods: {
    save() {
      cursoInstrutorRepository.create(this.curso).then((response) => {
        this.perfil.cursosInstrutor.push(response.data);
        this.toogleForm();
        this.$store.dispatch('app/success', {
          response,
          message: 'Curso cadastrado com sucesso!',
        });
      });
    },
    remove(curso) {
      if (curso) {
        cursoInstrutorRepository.delete(curso.id).then((response) => {
          this.perfil.cursosInstrutor = this.perfil.cursosInstrutor.filter((c) => c.id !== curso.id);
          this.$store.dispatch('app/success', {
            response,
            message: 'Curso excluído com sucesso!',
          });
        });
      }
    },
    toogleForm() {
      this.dialog = !this.dialog;
      this.curso = { id: null, nome: '', tipo: this.tipo };
    },
  },
};
</script>
